<template>
    <div>
        <div :class="{'show': toggleModal }" class="modal fade">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header border-bottom">
                        <h5 class="modal-title h4">{{$t('table.header.gallery')}}
                            <small class="m-0 text-muted">{{$t('table.header.gallery')}} - "{{name}}"</small>
                        </h5>
                        <button type="button" class="close" @click="toggleModal = !toggleModal">
                            <span aria-hidden="true"><i class="fal fa-times"></i></span>
                        </button>
                    </div>
                    <div class="modal-body modal-body-lg pb-5">
                        <div v-if="isSpinnerShow" class="d-flex justify-content-center mt-3 mb-3">
                            <b-spinner label="Loading..."></b-spinner>
                        </div>
                        <div class="panel-tag mt-3" v-if="!isSpinnerShow && gallery.length == 0">{{$t('message.info.no_records_image')}}</div>
                        <div v-if="!isSpinnerShow && gallery.length != 0" class="w-75 m-auto">
                            <div class="p-5 panel">
                                <div class="text-right mb-2 mr-2">
                                    <button class="btn btn-sm btn-outline-primary" type="button" title="Delete Image" @click="showDeleteModal">
                                        <span class="fal fa-trash" ></span>
                                    </button>
                                </div>
                                <lingallery ref="lingallery" class="text-center" 
                                    :items="gallery"
                                    :showThumbnails="true"
                                    :responsive="true"
                                    :disableImageClick="true"
                                    accentColor="#886ab5"
                                    :iid.sync="currentId"
                                />
                            </div>
                        </div>
                        <h6 class="text-dark fw-500">{{$t('header.upload_image')}}: </h6>
                         <vue-dropzone id="dzStaffImage" ref="dropzone" class="text-center mt-3 mb-5" :options="dropOptions" @vdropzone-success="dropLogo"></vue-dropzone>
                    </div>
                </div>
            </div>
        </div>
       <deleteModal ref="deleteModal" @performConfirmAction="deleteImage"></deleteModal>
    </div>
</template>
<script>
import DeleteModal from './../../Delete_Modal'
import {handleSessionExpired} from './../../../../assets/js/dashboard/dashboard'
import vueDropzone from "vue2-dropzone";
import Lingallery from 'lingallery';
export default {
    name: "serviceGallery",
    components:{
        vueDropzone, Lingallery, DeleteModal
    },
    data(){
        return{

            toggleModal: false, name: "", skuID: 0, gallery: [], 
            isSpinnerShow: false, addToggle: false, 
            dropOptions: {
                url: this.$api.API_IMAGE,
                addRemoveLinks: true,
                paramName: 'filename',
                headers:{
                    token: this.$util.getSessionToken()
                }
            },
            currentId: null
        }
    },
    methods:{
        async closeModal(isError){
            if(!isError){
                await this.setGallery()
                this.$refs.deleteModal.toggleModal = false
            }
            this.$parent.$parent.$parent.isModalShow = false;
        },
        editServiceGallery(id, name){
            this.skuID = id
            this.name = name
            
            this.toggleModal = true
            this.setGallery()
        },
        async setGallery(){
            this.gallery = []
            this.isSpinnerShow = true
            var result = await this.getGallery()
            var gallery = new Array()
            for(var i=0; i<result.length; i++){
                gallery.push({
                    id: result[i].imageID,
                    src: result[i].path,
                    thumbnail: result[i].path,
                })
            }

            this.gallery = gallery

            this.isSpinnerShow = false
        },
        async getGallery(){
            let $vm = this
            let url = this.$api.MENU_ITEM + "/" + this.skuID + this.$api.IMAGES

            var result = []
            await $vm.$axios({
                method: 'get', 
                url: url,
                baseURL: $vm.$axios.defaults.baseURL, 
                headers: {token: $vm.$session.get('token')}
            })
            .then(function(response) {
                result = response.data.result
                
            })
            .catch((err) => {
                var errData = err.response.data;
                if(errData.error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();  
                }
            })
            return result
        },
        dropLogo(file, response){
            if(response.path == undefined){
                this.parent.$parent.$parent.setModal(this, false, true, this.$i18n.t('message.error.upload'));
            }
            var data = {
                path: response.path
            }

            let $vm = this
            let url = this.$api.MENU_ITEM + "/" + this.skuID + this.$api.IMAGES
            $vm.$axios({
                method: 'post', 
                url: url,
                baseURL: $vm.$axios.defaults.baseURL, 
                headers: {token: $vm.$session.get('token')},
                data: data
            })
            .then(function(response) {
                if(response.status == 200){
                    $vm.$parent.$parent.$parent.setModal($vm, false, true, $vm.$i18n.t('message.success.upload'));
                    $vm.gallery = []
                }
            })
            .catch((err) => {
                var errData = err.response.data;
                if(errData.error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();  
                }
            })
            this.$refs.dropzone.removeFile(file)
        },
        showDeleteModal(){
            var title = this.$i18n.t('header.delete_image')
            var message = this.$i18n.t('message.confirmation.delete_image')
            this.$refs.deleteModal.showModal(title, message)
        },
        deleteImage(){
            let $vm = this
            let QUERY_STRING = this.$refs.lingallery._data.currentId + this.$api.DELETE
            let url = this.$api.MENU_ITEM + "/" + this.skuID + this.$api.IMAGES + "/" + QUERY_STRING
            $vm.$axios({
                method: 'post', 
                url: url,
                baseURL: $vm.$axios.defaults.baseURL, 
                headers: {token: $vm.$session.get('token')},
            })
            .then(function(response) {
                if(response.status == 200){
                    $vm.$parent.$parent.$parent.setModal($vm, false, true, $vm.$i18n.t('message.success.delete_image'));
                }
            })
            .catch((err) => {
                var errData = err.response.data;
                if(errData.error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();  
                }
            })
        },
    },
}
</script>
<style scoped>
.show{
    display: block;
}
.modal-body-lg{
    min-height: 65vh;
    max-height: 75vh;
    overflow-y: auto;
}
</style>